unit GiftAidDetailsForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseForm,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  WEBLib.Toast,
  Vcl.Controls,
  WEBLib.WebCtrls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  WEBLib.Grids,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  GiftAid.Entities.Claims.Enumerations;

type
  TGiftAidDetails = class(TBaseEditForm)
    GiftAidId: TDBLabel;
    TransactionId: TDBLabel;
    CorrelationId: TDBLabel;
    ClaimRef: TDBLabel;
    ClaimStatus: TDBLabel;
    SubmissionDate: TDBLabel;
    IRMark: TDBLabel;
    R68Link: TLabel;
    HMRCErrorMessage: THTMLSpan;
    SubmitJobLink: TLabel;
    ClaimStats: TXDataWebDataSet;
    ClaimStatsSource: TDataSource;
    ClaimStatsId: TIntegerField;
    ClaimStatsClaimId: TIntegerField;
    ClaimStatsGiftAid: TFloatField;
    ClaimStatsAmount: TFloatField;
    ClaimStatsClaimType: TStringField;
    ClaimStatsItemCount: TIntegerField;
    ClaimStatsTable: TDBTableControl;
    ClaimStatsClaim_Type: TStringField;
    ClaimStatsTaxYear: TIntegerField;
    IRMarkReceipt: THTMLSpan;
    DeclarationEvidence: THTMLSpan;
    ClaimDeclaration: TXDataWebDataSet;
    ClaimDeclarationId: TIntegerField;
    ClaimDeclarationClaimId: TIntegerField;
    ClaimDeclarationDeclarationVersion: TIntegerField;
    ClaimDeclarationDeclarationHash: TStringField;
    ClaimDeclarationDeclarationSignedDate: TDateTimeField;
    ClaimDeclarationDeclarationExpiryDate: TDateTimeField;
    ClaimDeclarationLastUpdated: TDateTimeField;
    ClaimDeclarationDeclarationSignedByUser: TIntegerField;
    ClaimDeclarationDeclarationSignedByName: TStringField;
    ClaimDeclarationDeclarationSigningChannel: TStringField;
    ClaimDeclarationDeclarationStatus: TStringField;
    ClaimDeclarationDeclarationRevokedDate: TDateTimeField;
    ClaimDeclarationSignedDeclarationText: TStringField;
    procedure ClaimStatsCalcFields(Dataset: TDataSet);
    procedure ClaimStatsAmountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
    procedure ClaimStatsGiftAidGetText(Sender: TField; var Text: string; DisplayText: Boolean);
    procedure ClaimStatsItemCountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
    procedure ClaimStatsAfterOpen(Dataset: TDataSet);
    procedure R68LinkClick(Sender: TObject);
    procedure SubmitJobLinkClick(Sender: TObject);
    procedure ClaimDeclarationAfterOpen(Dataset: TDataSet);
  private
    [async]
    procedure DownloadR68; async;
    [async]
    procedure OpenSubmitJob; async;
    procedure UpdateHMRCErrorDisplay(AClaimStatus: TGiftAidClaimStatus);
    procedure LoadClaimDeclarationEvidence;
    procedure RenderClaimDeclarationEvidence;
    procedure SetElementDisplay(const AElementId: string; AVisible: Boolean);
    function HtmlEscape(const AValue: string): string;
    function DeclarationStatusBadgeClass(const AStatus: string): string;
    { Private declarations }
  protected
    procedure RecordChanged; override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  GiftAidDetails: TGiftAidDetails;

implementation

uses
  System.Rtti,
  XData.Web.Client,
  MainDataModule,
  SMX.Web.Utils,
  SMX.Web.FileSupport,
  GiftAidClaimsList,
  SMX.ReturnTypes,
  SharedDataModule,
  Job.DetailForm.Manager,
  JobDetailBaseForm,
  JobDetailForm;

{$R *.dfm}

procedure TGiftAidDetails.ClaimStatsAmountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatGBP((Sender as TFloatField).AsFloat);
end;

procedure TGiftAidDetails.ClaimStatsCalcFields(Dataset: TDataSet);
var
  lValue: string;
  lType: TGiftAidClaimType;
begin
  lValue := Dataset.FieldByName('ClaimType').AsString;
  { TODO : Should be able to do this with TRttiEnumerationType, but it doesn't work }
  if lValue = 'GAD' then
    lType := TGiftAidClaimType.GAD
  else if lValue = 'GASDS' then
    lType := TGiftAidClaimType.GASDS
  else if lValue = 'Adjustment' then
    lType := TGiftAidClaimType.Adjustment
  else if lValue = 'GASDSAdjustment' then
    lType := TGiftAidClaimType.GASDSAdjustment
  else if lValue = 'AggregatedDonations' then
    lType := TGiftAidClaimType.AggregatedDonations
  else if lValue = 'CommunityBuildings' then
    lType := TGiftAidClaimType.CommunityBuildings
  else if lValue = 'OtherIncome' then
    lType := TGiftAidClaimType.OtherIncome
  else
  begin
    Dataset.FieldByName('Claim_Type').AsString := 'unknown';
    Exit;
  end;

  Dataset.FieldByName('Claim_Type').AsString := C_GA_TYPE_DESCRIPTIONS[lType];
end;

procedure TGiftAidDetails.ClaimStatsGiftAidGetText(Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatGBP((Sender as TFloatField).AsFloat);
end;

procedure TGiftAidDetails.ClaimStatsItemCountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := FormatFloat('#,##0', (Sender as TIntegerField).AsInteger);
end;

procedure TGiftAidDetails.DownloadR68;
var
  lResponse: TXDataClientResponse;
  lResponseObject: JS.TJSObject;
  lOutcome: TResponseOutcome;
  lFileName: string;
begin

  lResponse := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetR68Report',
    [DataSource.Dataset.FieldByName('Id').AsInteger]));

  lResponseObject := lResponse.ResultAsObject;

  if lResponseObject = nil then
  begin
    ShowMessage('Failed to download report');
    Exit;
  end;

  lOutcome := TRttiEnumerationType.GetValue<TResponseOutcome>(JS.toString(lResponseObject['Outcome']));

  if lOutcome = responseFileNotFound then
  begin
    ShowMessage('Sorry, we can''t find the R68 report. Please contact the GiftAider support team');
    Exit;
  end;

  try
    lFileName := JS.toString(lResponseObject['TheFileName']);
    TFileSupport.SaveEncoded64File(lFileName, JS.toString(lResponseObject['Data']));
  except
    on E: Exception do
    begin
      ShowMessage(E.Message);
    end;
  end;
end;

procedure TGiftAidDetails.R68LinkClick(Sender: TObject);
begin
  DownloadR68;
end;

{ TGiftAidDetails }

procedure TGiftAidDetails.UpdateHMRCErrorDisplay(AClaimStatus: TGiftAidClaimStatus);
var
  lComments: string;
begin
  lComments := Dataset.FieldByName('Comments').AsString;
  if AClaimStatus in [TGiftAidClaimStatus.Error, TGiftAidClaimStatus.SysError, TGiftAidClaimStatus.DataError] then
  begin
    HMRCErrorMessage.Visible := lComments <> '';
    if lComments <> '' then
      HMRCErrorMessage.HTML.Text := '<div class="alert alert-danger mb-2">' + lComments + '</div>';
  end
  else
    HMRCErrorMessage.Visible := False;
end;

procedure TGiftAidDetails.OpenSubmitJob;
var
  lJobId: Integer;
  AForm: TJobDetailBase;
  lField: TField;
begin
  lField := Dataset.FindField('SubmitJobId');
  if (lField = nil) or lField.IsNull then
  begin
    ShowMessage('No submit job is linked to this claim.');
    Exit;
  end;

  lJobId := lField.AsInteger;
  if lJobId <= 0 then
  begin
    ShowMessage('No submit job is linked to this claim.');
    Exit;
  end;

  if not SharedData.JobsDataset.Active then
    SharedData.LoadJobs;

  if not SharedData.JobsDataset.Locate('Id', lJobId, []) then
  begin
    ShowMessage('The linked submit job could not be found. It may have been archived.');
    Exit;
  end;

  AForm := FindJobDetailForm(Self, SharedData.JobsDataset.FieldByName('JobType').AsString);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    await(TJobDetailBase, AForm.Load());
    AForm.Dataset := SharedData.JobsDataset;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
  end;
end;

procedure TGiftAidDetails.SubmitJobLinkClick(Sender: TObject);
begin
  OpenSubmitJob;
end;

procedure TGiftAidDetails.ClaimStatsAfterOpen(Dataset: TDataSet);
begin
  SetElementDisplay('ClaimStatsSection', ClaimStats.Active and (not ClaimStats.IsEmpty));
  ClaimStatsTable.Visible := ClaimStats.Active and (not ClaimStats.IsEmpty);
end;

procedure TGiftAidDetails.ClaimDeclarationAfterOpen(Dataset: TDataSet);
begin
  RenderClaimDeclarationEvidence;
end;

function TGiftAidDetails.HtmlEscape(const AValue: string): string;
begin
  Result := AValue;
  Result := StringReplace(Result, '&', '&amp;', [rfReplaceAll]);
  Result := StringReplace(Result, '<', '&lt;', [rfReplaceAll]);
  Result := StringReplace(Result, '>', '&gt;', [rfReplaceAll]);
  Result := StringReplace(Result, '"', '&quot;', [rfReplaceAll]);
end;

function TGiftAidDetails.DeclarationStatusBadgeClass(const AStatus: string): string;
begin
  if SameText(AStatus, 'Signed') then
    Result := 'bg-success'
  else if SameText(AStatus, 'Used') then
    Result := 'bg-primary'
  else if SameText(AStatus, 'Expired') then
    Result := 'bg-warning text-dark'
  else if SameText(AStatus, 'Revoked') or SameText(AStatus, 'Voided') then
    Result := 'bg-danger'
  else
    Result := 'bg-secondary';
end;

procedure TGiftAidDetails.SetElementDisplay(const AElementId: string; AVisible: Boolean);
var
  lEl: TJSHTMLElement;
begin
  lEl := TJSHTMLElement(document.getElementById(AElementId));
  if not Assigned(lEl) then
    Exit;
  if AVisible then
    lEl.style.setProperty('display', '')
  else
    lEl.style.setProperty('display', 'none');
end;

procedure TGiftAidDetails.LoadClaimDeclarationEvidence;
var
  lClaimId: string;
begin
  DeclarationEvidence.HTML.Text := '';
  DeclarationEvidence.Visible := False;
  lClaimId := DataSource.Dataset.FieldByName('Id').AsString;
  if (lClaimId = '') or (lClaimId = '0') then
    Exit;
  ClaimDeclaration.Close;
  ClaimDeclaration.QueryString := '$filter=ClaimId eq ' + lClaimId + '&$orderby=Id desc';
  ClaimDeclaration.Load;
end;

procedure TGiftAidDetails.RenderClaimDeclarationEvidence;
var
  lHtml: string;
  lText: string;
  lSignedAt: string;
  lStatus: string;
  lSigner: string;
  lChannel: string;
  lHash: string;
begin
  if (not ClaimDeclaration.Active) or ClaimDeclaration.IsEmpty then
  begin
    DeclarationEvidence.HTML.Text := '';
    DeclarationEvidence.Visible := False;
    Exit;
  end;

  ClaimDeclaration.First;
  lStatus := ClaimDeclarationDeclarationStatus.AsString;
  if lStatus = '' then
    lStatus := 'Unknown';
  lText := HtmlEscape(ClaimDeclarationSignedDeclarationText.AsString);
  lText := StringReplace(lText, #13#10, '<br>', [rfReplaceAll]);
  lText := StringReplace(lText, #10, '<br>', [rfReplaceAll]);
  lSigner := HtmlEscape(ClaimDeclarationDeclarationSignedByName.AsString);
  lChannel := HtmlEscape(ClaimDeclarationDeclarationSigningChannel.AsString);
  lHash := HtmlEscape(ClaimDeclarationDeclarationHash.AsString);

  if ClaimDeclarationDeclarationSignedDate.AsDateTime > 0 then
    lSignedAt := FormatDateTime('yyyy-mm-dd hh:nn:ss', ClaimDeclarationDeclarationSignedDate.AsDateTime)
  else
    lSignedAt := '—';

  lHtml :=
    '<div class="declaration-panel">' +
      '<div class="declaration-panel-title">Declaration evidence' +
        ' <span class="badge ' + DeclarationStatusBadgeClass(lStatus) + '">' + HtmlEscape(lStatus) + '</span>' +
        ' <span class="badge bg-secondary">read-only</span>' +
      '</div>' +
      '<dl class="declaration-grid">' +
        '<dt>Version</dt><dd>' + ClaimDeclarationDeclarationVersion.AsString + '</dd>' +
        '<dt>Hash</dt><dd class="declaration-hash" title="' + lHash + '">' + lHash + '</dd>' +
        '<dt>Signed by</dt><dd>' + lSigner +
          ' <span class="text-muted">(user ' + ClaimDeclarationDeclarationSignedByUser.AsString + ')</span></dd>' +
        '<dt>Signed at</dt><dd>' + lSignedAt + '</dd>' +
        '<dt>Channel</dt><dd>' + lChannel + '</dd>' +
      '</dl>' +
      '<div class="claim-meta-label mb-1">Declaration text</div>' +
      '<div class="declaration-text">' + lText + '</div>' +
    '</div>';

  DeclarationEvidence.HTML.Text := lHtml;
  DeclarationEvidence.Visible := True;
end;

procedure TGiftAidDetails.RecordChanged;
var
  lClaimStatus: TGiftAidClaimStatus;
  lHasSubmitJob: Boolean;
  lHasIRMarkReceipt: Boolean;
  lField: TField;
begin
  inherited;
  FormCaption.Caption := DataSource.Dataset.FieldByName('ClaimRef').AsString;
  lClaimStatus := TRttiEnumerationType.GetValue<TGiftAidClaimStatus>(DataSource.Dataset.FieldByName('ClaimStatus')
    .AsString);
  R68Link.Visible := (lClaimStatus in [TGiftAidClaimStatus.Acknowledged, TGiftAidClaimStatus.Confirmed,
    TGiftAidClaimStatus.PaymentReceived, TGiftAidClaimStatus.ClaimRejected]);

  UpdateHMRCErrorDisplay(lClaimStatus);

  lField := Dataset.FindField('SubmitJobId');
  lHasSubmitJob := Assigned(lField) and (not lField.IsNull) and (lField.AsInteger > 0);
  SubmitJobLink.Visible := lHasSubmitJob and (lClaimStatus in [TGiftAidClaimStatus.Error,
    TGiftAidClaimStatus.SysError, TGiftAidClaimStatus.DataError, TGiftAidClaimStatus.Acknowledged,
    TGiftAidClaimStatus.Submitting]);

  lHasIRMarkReceipt := Dataset.FieldByName('IRMarkReceipt').AsString <> '';
  if lHasIRMarkReceipt then
    IRMarkReceipt.HTML.Text := Dataset.FieldByName('IRMarkReceipt').AsString
  else
    IRMarkReceipt.HTML.Text := '';
  // Keep the receipt text in the DOM for PDF generation, but never show it inline.
  IRMarkReceipt.Visible := False;
  SetElementDisplay('IRMarkReceiptButton', lHasIRMarkReceipt);

  SetElementDisplay('ClaimStatsSection', False);
  ClaimStats.QueryString := '$filter=ClaimId eq ' + DataSource.Dataset.FieldByName('Id').AsString;
  ClaimStats.Load;
  LoadClaimDeclarationEvidence;
end;

procedure TGiftAidDetails.LoadDFMValues;
begin
  inherited LoadDFMValues;

  GiftAidId := TDBLabel.Create('GiftAidId');
  TransactionId := TDBLabel.Create('TransactionId');
  CorrelationId := TDBLabel.Create('CorrelationId');
  ClaimRef := TDBLabel.Create('ClaimRef');
  ClaimStatus := TDBLabel.Create('ClaimStatus');
  HMRCErrorMessage := THTMLSpan.Create('HMRCErrorMessage');
  SubmitJobLink := TLabel.Create('SubmitJobLink');
  SubmissionDate := TDBLabel.Create('SubmissionDate');
  IRMark := TDBLabel.Create('IRMark');
  R68Link := TLabel.Create('R68Link');
  ClaimStatsTable := TDBTableControl.Create('ClaimStatsTable');
  IRMarkReceipt := THTMLSpan.Create('IRMarkReceipt');
  ClaimStats := TXDataWebDataSet.Create(Self);
  ClaimStatsId := TIntegerField.Create(Self);
  ClaimStatsClaimId := TIntegerField.Create(Self);
  ClaimStatsGiftAid := TFloatField.Create(Self);
  ClaimStatsAmount := TFloatField.Create(Self);
  ClaimStatsClaimType := TStringField.Create(Self);
  ClaimStatsItemCount := TIntegerField.Create(Self);
  ClaimStatsClaim_Type := TStringField.Create(Self);
  ClaimStatsTaxYear := TIntegerField.Create(Self);
  ClaimStatsSource := TDataSource.Create(Self);
  DeclarationEvidence := THTMLSpan.Create('DeclarationEvidence');
  ClaimDeclaration := TXDataWebDataSet.Create(Self);
  ClaimDeclarationId := TIntegerField.Create(Self);
  ClaimDeclarationClaimId := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationVersion := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationHash := TStringField.Create(Self);
  ClaimDeclarationDeclarationSignedDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationExpiryDate := TDateTimeField.Create(Self);
  ClaimDeclarationLastUpdated := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationSignedByUser := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationSignedByName := TStringField.Create(Self);
  ClaimDeclarationDeclarationSigningChannel := TStringField.Create(Self);
  ClaimDeclarationDeclarationStatus := TStringField.Create(Self);
  ClaimDeclarationDeclarationRevokedDate := TDateTimeField.Create(Self);
  ClaimDeclarationSignedDeclarationText := TStringField.Create(Self);

  GiftAidId.BeforeLoadDFMValues;
  TransactionId.BeforeLoadDFMValues;
  CorrelationId.BeforeLoadDFMValues;
  ClaimRef.BeforeLoadDFMValues;
  ClaimStatus.BeforeLoadDFMValues;
  HMRCErrorMessage.BeforeLoadDFMValues;
  SubmitJobLink.BeforeLoadDFMValues;
  SubmissionDate.BeforeLoadDFMValues;
  IRMark.BeforeLoadDFMValues;
  R68Link.BeforeLoadDFMValues;
  ClaimStatsTable.BeforeLoadDFMValues;
  IRMarkReceipt.BeforeLoadDFMValues;
  ClaimStats.BeforeLoadDFMValues;
  ClaimStatsId.BeforeLoadDFMValues;
  ClaimStatsClaimId.BeforeLoadDFMValues;
  ClaimStatsGiftAid.BeforeLoadDFMValues;
  ClaimStatsAmount.BeforeLoadDFMValues;
  ClaimStatsClaimType.BeforeLoadDFMValues;
  ClaimStatsItemCount.BeforeLoadDFMValues;
  ClaimStatsClaim_Type.BeforeLoadDFMValues;
  ClaimStatsTaxYear.BeforeLoadDFMValues;
  ClaimStatsSource.BeforeLoadDFMValues;
  DeclarationEvidence.BeforeLoadDFMValues;
  ClaimDeclaration.BeforeLoadDFMValues;
  ClaimDeclarationId.BeforeLoadDFMValues;
  ClaimDeclarationClaimId.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationVersion.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationHash.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationExpiryDate.BeforeLoadDFMValues;
  ClaimDeclarationLastUpdated.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedByUser.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedByName.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSigningChannel.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationStatus.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationRevokedDate.BeforeLoadDFMValues;
  ClaimDeclarationSignedDeclarationText.BeforeLoadDFMValues;
  try
    GiftAidId.SetParentComponent(Self);
    GiftAidId.Name := 'GiftAidId';
    GiftAidId.Left := 48;
    GiftAidId.Top := 104;
    GiftAidId.Width := 47;
    GiftAidId.Height := 15;
    GiftAidId.Caption := 'GiftAidId';
    GiftAidId.ElementFont := efCSS;
    GiftAidId.HeightStyle := ssAuto;
    GiftAidId.HeightPercent := 100.000000000000000000;
    GiftAidId.WidthPercent := 100.000000000000000000;
    GiftAidId.DataField := 'Id';
    GiftAidId.DataSource := DataSource;
    TransactionId.SetParentComponent(Self);
    TransactionId.Name := 'TransactionId';
    TransactionId.Left := 48;
    TransactionId.Top := 136;
    TransactionId.Width := 70;
    TransactionId.Height := 15;
    TransactionId.Caption := 'TransactionId';
    TransactionId.ElementFont := efCSS;
    TransactionId.HeightStyle := ssAuto;
    TransactionId.HeightPercent := 100.000000000000000000;
    TransactionId.WidthPercent := 100.000000000000000000;
    TransactionId.DataField := 'TransactionId';
    TransactionId.DataSource := DataSource;
    CorrelationId.SetParentComponent(Self);
    CorrelationId.Name := 'CorrelationId';
    CorrelationId.Left := 48;
    CorrelationId.Top := 150;
    CorrelationId.Width := 76;
    CorrelationId.Height := 15;
    CorrelationId.Caption := 'Correlation Id';
    CorrelationId.ElementFont := efCSS;
    CorrelationId.HeightStyle := ssAuto;
    CorrelationId.HeightPercent := 100.000000000000000000;
    CorrelationId.WidthPercent := 100.000000000000000000;
    CorrelationId.ElementPosition := epIgnore;
    CorrelationId.DataField := 'CorrelationId';
    CorrelationId.DataSource := DataSource;
    ClaimRef.SetParentComponent(Self);
    ClaimRef.Name := 'ClaimRef';
    ClaimRef.Left := 48;
    ClaimRef.Top := 165;
    ClaimRef.Width := 48;
    ClaimRef.Height := 15;
    ClaimRef.Caption := 'ClaimRef';
    ClaimRef.ElementFont := efCSS;
    ClaimRef.HeightStyle := ssAuto;
    ClaimRef.HeightPercent := 100.000000000000000000;
    ClaimRef.WidthPercent := 100.000000000000000000;
    ClaimRef.DataField := 'ClaimRef';
    ClaimRef.DataSource := DataSource;
    ClaimStatus.SetParentComponent(Self);
    ClaimStatus.Name := 'ClaimStatus';
    ClaimStatus.Left := 48;
    ClaimStatus.Top := 180;
    ClaimStatus.Width := 63;
    ClaimStatus.Height := 15;
    ClaimStatus.Caption := 'ClaimStatus';
    ClaimStatus.ElementFont := efCSS;
    ClaimStatus.HeightStyle := ssAuto;
    ClaimStatus.HeightPercent := 100.000000000000000000;
    ClaimStatus.WidthPercent := 100.000000000000000000;
    ClaimStatus.DataField := 'ClaimStatus';
    ClaimStatus.DataSource := DataSource;
    HMRCErrorMessage.SetParentComponent(Self);
    HMRCErrorMessage.Name := 'HMRCErrorMessage';
    HMRCErrorMessage.Left := 48;
    HMRCErrorMessage.Top := 210;
    HMRCErrorMessage.Width := 480;
    HMRCErrorMessage.Height := 40;
    HMRCErrorMessage.HeightStyle := ssAuto;
    HMRCErrorMessage.WidthStyle := ssAuto;
    HMRCErrorMessage.ChildOrder := 5;
    HMRCErrorMessage.ElementPosition := epIgnore;
    HMRCErrorMessage.Visible := False;
    HMRCErrorMessage.Role := '';
    SubmitJobLink.SetParentComponent(Self);
    SubmitJobLink.Name := 'SubmitJobLink';
    SubmitJobLink.Left := 48;
    SubmitJobLink.Top := 255;
    SubmitJobLink.Width := 120;
    SubmitJobLink.Height := 15;
    SubmitJobLink.Cursor := crHandPoint;
    SubmitJobLink.Caption := 'View submit job';
    SubmitJobLink.ElementFont := efCSS;
    SubmitJobLink.HeightStyle := ssAuto;
    SubmitJobLink.HeightPercent := 100.000000000000000000;
    SubmitJobLink.Visible := False;
    SubmitJobLink.WidthPercent := 100.000000000000000000;
    SubmitJobLink.ElementPosition := epIgnore;
    SetEvent(SubmitJobLink, Self, 'OnClick', 'SubmitJobLinkClick');
    SubmissionDate.SetParentComponent(Self);
    SubmissionDate.Name := 'SubmissionDate';
    SubmissionDate.Left := 48;
    SubmissionDate.Top := 195;
    SubmissionDate.Width := 85;
    SubmissionDate.Height := 15;
    SubmissionDate.Caption := 'SubmissionDate';
    SubmissionDate.ElementFont := efCSS;
    SubmissionDate.HeightStyle := ssAuto;
    SubmissionDate.HeightPercent := 100.000000000000000000;
    SubmissionDate.WidthPercent := 100.000000000000000000;
    SubmissionDate.DataField := 'SubmissionDate';
    SubmissionDate.DataSource := DataSource;
    IRMark.SetParentComponent(Self);
    IRMark.Name := 'IRMark';
    IRMark.Left := 48;
    IRMark.Top := 195;
    IRMark.Width := 37;
    IRMark.Height := 15;
    IRMark.Caption := 'IRMark';
    IRMark.ElementFont := efCSS;
    IRMark.HeightStyle := ssAuto;
    IRMark.HeightPercent := 100.000000000000000000;
    IRMark.WidthPercent := 100.000000000000000000;
    IRMark.DataField := 'IRMark';
    IRMark.DataSource := DataSource;
    R68Link.SetParentComponent(Self);
    R68Link.Name := 'R68Link';
    R68Link.Left := 48;
    R68Link.Top := 240;
    R68Link.Width := 57;
    R68Link.Height := 15;
    R68Link.Cursor := crHandPoint;
    R68Link.Caption := 'R68 Report';
    R68Link.ElementFont := efCSS;
    R68Link.HeightStyle := ssAuto;
    R68Link.HeightPercent := 100.000000000000000000;
    R68Link.Visible := False;
    R68Link.WidthPercent := 100.000000000000000000;
    SetEvent(R68Link, Self, 'OnClick', 'R68LinkClick');
    ClaimStatsTable.SetParentComponent(Self);
    ClaimStatsTable.Name := 'ClaimStatsTable';
    ClaimStatsTable.Left := 560;
    ClaimStatsTable.Top := 136;
    ClaimStatsTable.Width := 300;
    ClaimStatsTable.Height := 200;
    ClaimStatsTable.HeightStyle := ssAuto;
    ClaimStatsTable.WidthStyle := ssAuto;
    ClaimStatsTable.BorderColor := clSilver;
    ClaimStatsTable.ChildOrder := 18;
    ClaimStatsTable.ElementPosition := epIgnore;
    ClaimStatsTable.Columns.Clear;
    with ClaimStatsTable.Columns.Add do
    begin
      DataField := 'Claim_Type';
      Title := 'Claim Type';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'Amount';
      Title := 'Amount';
      TitleElementClassName := 'text-end';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'GiftAid';
      Title := 'Gift Aid';
      TitleElementClassName := 'text-end';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'TaxYear';
      Title := 'Tax Year';
      TitleElementClassName := 'text-end';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'ItemCount';
      Title := 'Count';
      TitleElementClassName := 'text-end';
    end;
    ClaimStatsTable.DataSource := ClaimStatsSource;
    IRMarkReceipt.SetParentComponent(Self);
    IRMarkReceipt.Name := 'IRMarkReceipt';
    IRMarkReceipt.Left := 252;
    IRMarkReceipt.Top := 240;
    IRMarkReceipt.Width := 100;
    IRMarkReceipt.Height := 40;
    IRMarkReceipt.WidthStyle := ssAuto;
    IRMarkReceipt.ChildOrder := 18;
    IRMarkReceipt.ElementPosition := epIgnore;
    IRMarkReceipt.Role := '';
    ClaimStats.SetParentComponent(Self);
    ClaimStats.Name := 'ClaimStats';
    ClaimStats.AfterOpen := ClaimStatsAfterOpen;
    SetEvent(ClaimStats, Self, 'OnCalcFields', 'ClaimStatsCalcFields');
    ClaimStats.EntitySetName := 'GiftAidClaimStats';
    ClaimStats.Connection := MainData.DataConnection;
    ClaimStats.Left := 520;
    ClaimStats.Top := 24;
    ClaimStatsId.SetParentComponent(ClaimStats);
    ClaimStatsId.Name := 'ClaimStatsId';
    ClaimStatsId.FieldName := 'Id';
    ClaimStatsId.Required := True;
    ClaimStatsClaimId.SetParentComponent(ClaimStats);
    ClaimStatsClaimId.Name := 'ClaimStatsClaimId';
    ClaimStatsClaimId.FieldName := 'ClaimId';
    ClaimStatsClaimId.Required := True;
    ClaimStatsGiftAid.SetParentComponent(ClaimStats);
    ClaimStatsGiftAid.Name := 'ClaimStatsGiftAid';
    ClaimStatsGiftAid.FieldName := 'GiftAid';
    ClaimStatsGiftAid.Required := True;
    SetEvent(ClaimStatsGiftAid, Self, 'OnGetText', 'ClaimStatsGiftAidGetText');
    ClaimStatsAmount.SetParentComponent(ClaimStats);
    ClaimStatsAmount.Name := 'ClaimStatsAmount';
    ClaimStatsAmount.FieldName := 'Amount';
    ClaimStatsAmount.Required := True;
    SetEvent(ClaimStatsAmount, Self, 'OnGetText', 'ClaimStatsAmountGetText');
    ClaimStatsClaimType.SetParentComponent(ClaimStats);
    ClaimStatsClaimType.Name := 'ClaimStatsClaimType';
    ClaimStatsClaimType.FieldName := 'ClaimType';
    ClaimStatsClaimType.Required := True;
    ClaimStatsClaimType.Size := 19;
    ClaimStatsItemCount.SetParentComponent(ClaimStats);
    ClaimStatsItemCount.Name := 'ClaimStatsItemCount';
    ClaimStatsItemCount.FieldName := 'ItemCount';
    ClaimStatsItemCount.Required := True;
    SetEvent(ClaimStatsItemCount, Self, 'OnGetText', 'ClaimStatsItemCountGetText');
    ClaimStatsClaim_Type.SetParentComponent(ClaimStats);
    ClaimStatsClaim_Type.Name := 'ClaimStatsClaim_Type';
    ClaimStatsClaim_Type.FieldKind := fkCalculated;
    ClaimStatsClaim_Type.FieldName := 'Claim_Type';
    ClaimStatsClaim_Type.Size := 30;
    ClaimStatsClaim_Type.Calculated := True;
    ClaimStatsTaxYear.SetParentComponent(ClaimStats);
    ClaimStatsTaxYear.Name := 'ClaimStatsTaxYear';
    ClaimStatsTaxYear.FieldName := 'TaxYear';
    ClaimStatsTaxYear.Required := True;
    ClaimStatsSource.SetParentComponent(Self);
    ClaimStatsSource.Name := 'ClaimStatsSource';
    ClaimStatsSource.DataSet := ClaimStats;
    ClaimStatsSource.Left := 608;
    ClaimStatsSource.Top := 24;
    DeclarationEvidence.SetParentComponent(Self);
    DeclarationEvidence.Name := 'DeclarationEvidence';
    DeclarationEvidence.Left := 48;
    DeclarationEvidence.Top := 300;
    DeclarationEvidence.Width := 480;
    DeclarationEvidence.Height := 40;
    DeclarationEvidence.HeightStyle := ssAuto;
    DeclarationEvidence.WidthStyle := ssAuto;
    DeclarationEvidence.ChildOrder := 20;
    DeclarationEvidence.ElementPosition := epIgnore;
    DeclarationEvidence.Visible := False;
    DeclarationEvidence.Role := '';
    ClaimDeclaration.SetParentComponent(Self);
    ClaimDeclaration.Name := 'ClaimDeclaration';
    ClaimDeclaration.AfterOpen := ClaimDeclarationAfterOpen;
    ClaimDeclaration.EntitySetName := 'ClaimDeclaration';
    ClaimDeclaration.Connection := MainData.DataConnection;
    ClaimDeclaration.Left := 520;
    ClaimDeclaration.Top := 80;
    ClaimDeclarationId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationId.Name := 'ClaimDeclarationId';
    ClaimDeclarationId.FieldName := 'Id';
    ClaimDeclarationClaimId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationClaimId.Name := 'ClaimDeclarationClaimId';
    ClaimDeclarationClaimId.FieldName := 'ClaimId';
    ClaimDeclarationDeclarationVersion.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationVersion.Name := 'ClaimDeclarationDeclarationVersion';
    ClaimDeclarationDeclarationVersion.FieldName := 'DeclarationVersion';
    ClaimDeclarationDeclarationHash.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationHash.Name := 'ClaimDeclarationDeclarationHash';
    ClaimDeclarationDeclarationHash.FieldName := 'DeclarationHash';
    ClaimDeclarationDeclarationHash.Size := 64;
    ClaimDeclarationDeclarationSignedDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedDate.Name := 'ClaimDeclarationDeclarationSignedDate';
    ClaimDeclarationDeclarationSignedDate.FieldName := 'DeclarationSignedDate';
    ClaimDeclarationDeclarationExpiryDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationExpiryDate.Name := 'ClaimDeclarationDeclarationExpiryDate';
    ClaimDeclarationDeclarationExpiryDate.FieldName := 'DeclarationExpiryDate';
    ClaimDeclarationLastUpdated.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationLastUpdated.Name := 'ClaimDeclarationLastUpdated';
    ClaimDeclarationLastUpdated.FieldName := 'LastUpdated';
    ClaimDeclarationDeclarationSignedByUser.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedByUser.Name := 'ClaimDeclarationDeclarationSignedByUser';
    ClaimDeclarationDeclarationSignedByUser.FieldName := 'DeclarationSignedByUser';
    ClaimDeclarationDeclarationSignedByName.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedByName.Name := 'ClaimDeclarationDeclarationSignedByName';
    ClaimDeclarationDeclarationSignedByName.FieldName := 'DeclarationSignedByName';
    ClaimDeclarationDeclarationSignedByName.Size := 100;
    ClaimDeclarationDeclarationSigningChannel.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSigningChannel.Name := 'ClaimDeclarationDeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.FieldName := 'DeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.Size := 10;
    ClaimDeclarationDeclarationStatus.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationStatus.Name := 'ClaimDeclarationDeclarationStatus';
    ClaimDeclarationDeclarationStatus.FieldName := 'DeclarationStatus';
    ClaimDeclarationDeclarationStatus.Size := 10;
    ClaimDeclarationDeclarationRevokedDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationRevokedDate.Name := 'ClaimDeclarationDeclarationRevokedDate';
    ClaimDeclarationDeclarationRevokedDate.FieldName := 'DeclarationRevokedDate';
    ClaimDeclarationSignedDeclarationText.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationSignedDeclarationText.Name := 'ClaimDeclarationSignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.FieldName := 'SignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.Size := 2048;
  finally
    GiftAidId.AfterLoadDFMValues;
    TransactionId.AfterLoadDFMValues;
    CorrelationId.AfterLoadDFMValues;
    ClaimRef.AfterLoadDFMValues;
    ClaimStatus.AfterLoadDFMValues;
    HMRCErrorMessage.AfterLoadDFMValues;
    SubmitJobLink.AfterLoadDFMValues;
    SubmissionDate.AfterLoadDFMValues;
    IRMark.AfterLoadDFMValues;
    R68Link.AfterLoadDFMValues;
    ClaimStatsTable.AfterLoadDFMValues;
    IRMarkReceipt.AfterLoadDFMValues;
    ClaimStats.AfterLoadDFMValues;
    ClaimStatsId.AfterLoadDFMValues;
    ClaimStatsClaimId.AfterLoadDFMValues;
    ClaimStatsGiftAid.AfterLoadDFMValues;
    ClaimStatsAmount.AfterLoadDFMValues;
    ClaimStatsClaimType.AfterLoadDFMValues;
    ClaimStatsItemCount.AfterLoadDFMValues;
    ClaimStatsClaim_Type.AfterLoadDFMValues;
    ClaimStatsTaxYear.AfterLoadDFMValues;
    ClaimStatsSource.AfterLoadDFMValues;
    DeclarationEvidence.AfterLoadDFMValues;
    ClaimDeclaration.AfterLoadDFMValues;
    ClaimDeclarationId.AfterLoadDFMValues;
    ClaimDeclarationClaimId.AfterLoadDFMValues;
    ClaimDeclarationDeclarationVersion.AfterLoadDFMValues;
    ClaimDeclarationDeclarationHash.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationExpiryDate.AfterLoadDFMValues;
    ClaimDeclarationLastUpdated.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedByUser.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedByName.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSigningChannel.AfterLoadDFMValues;
    ClaimDeclarationDeclarationStatus.AfterLoadDFMValues;
    ClaimDeclarationDeclarationRevokedDate.AfterLoadDFMValues;
    ClaimDeclarationSignedDeclarationText.AfterLoadDFMValues;
  end;
end;

end.
